import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/inbound-calls.svg'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = { style: {"margin":"-53px -9px -30px -11px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-1 pb-4 position-relative z-1" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Inbound Calls"),
          _createElementVNode("span", { class: "fs-12" }, "Overview of incoming call volume")
        ]),
        _createElementVNode("div", {
          class: "dropdown select-dropdown without-border position-relative",
          style: {"right":"-5px"}
        }, [
          _createElementVNode("button", {
            class: "dropdown-toggle bg-transparent border text-body rounded-2",
            style: {"padding-right":"20px"},
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " Today "),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Today ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Month ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "164",
              options: _ctx.inboundCalls,
              series: _ctx.calls
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex align-items-center position-relative z-1\"><div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><div class=\"bg-body-bg border text-center rounded-2\" style=\"width:48px;height:48px;line-height:48px;\"><img src=\"" + _imports_0 + "\" alt=\"inbound-calls\"></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-28 fw-semibold text-secondary mb-0\">1,235</h3><span class=\"text-body d-block\">Past 24 hours</span></div></div><span class=\"d-flex align-items-center align-items-center text-body ms-5\"><i class=\"material-symbols-outlined fs-18 pe-2 text-success-60\"> trending_up </i><span class=\"fw-medium me-1 text-secondary\">+7.5%</span></span></div>", 1))
    ])
  ]))
}